import { startCase } from "lodash";
import i18n from "i18next";
const toPercent = (part, total) => {
  if (!total || Number.isNaN(total)) {
    return 0;
  }
  return (part / total) * 100;
};
export const buildMassSeries = ({
  materialDelivery = [],
  totalWasteMass = 0,
  colorWhenOverLimit = "#FF9494",
  defaultBarColor = "rgba(75,192,192,0.6)",
  parentCategoriesList = [],
  categoryMassThreshold = 30,
}) => {
  const labels = materialDelivery.map((material) =>
    startCase(i18n.t(material.cls)),
  );
  const values = materialDelivery.map((material) =>
    toPercent(material.massObject, totalWasteMass),
  );
  const parentCategoriesOverLimit = parentCategoriesList.filter((category) => {
    const massPercent = toPercent(category.massObjects, totalWasteMass);
    const outletPercent = toPercent(category.massInOutlet, totalWasteMass);
    return (
      massPercent > categoryMassThreshold &&
      outletPercent > categoryMassThreshold &&
      i18n.t("Other") !== i18n.t(category.parentCategory)
    );
  });
  const colors = materialDelivery.map((material) => {
    const isOverLimit = parentCategoriesOverLimit.some(
      (cat) => i18n.t(cat.parentCategory) === i18n.t(material.parentCategory),
    );
    return isOverLimit ? colorWhenOverLimit : defaultBarColor;
  });
  return {
    labels,
    values,
    colors,
    parentCategoriesOverLimit,
  };
};
export const buildVolumeSeries = ({
  materialDelivery = [],
  totalWasteVolume = 0,
  totalVolumeRecoverable = 0,
  recoverableMaterialList = [],
}) => {
  const labels = materialDelivery.map((material) =>
    startCase(i18n.t(material.cls)),
  );
  const values = materialDelivery.map((material) =>
    toPercent(material.volumeObject, totalWasteVolume),
  );
  const recoverableBreakdown = recoverableMaterialList.map((item) => {
    const key = Object.keys(item)[0];
    const { volumeObject } = item[key];
    return {
      label: startCase(key),
      value: toPercent(volumeObject, totalWasteVolume),
    };
  });
  const recoverableRatio = toPercent(
    totalVolumeRecoverable,
    totalWasteVolume,
  ).toFixed(1);
  return {
    labels,
    values,
    recoverableBreakdown,
    recoverableRatio: Number(recoverableRatio),
  };
};
export const buildObjectsSeries = ({ materialDelivery = [] }) => {
  return materialDelivery.map((material) => ({
    label: startCase(i18n.t(material.cls)),
    value: material.count,
  }));
};
export const buildOutletSeries = ({
  recoverableWithOutlet = 0,
  recoverableWithNoOutlet = 0,
  totalMassRecoverable = 0,
  totalWasteMass = 0,
  parentCategoriesList = [],
}) => {
  const withOutletPercent = toPercent(
    recoverableWithOutlet,
    totalMassRecoverable,
  );
  const withoutOutletPercent = toPercent(
    recoverableWithNoOutlet,
    totalMassRecoverable,
  );
  const rows = parentCategoriesList.map((category) => ({
    label: startCase(i18n.t(category.parentCategory)),
    withChannel: category.massInOutlet?.toFixed(1) ?? 0,
    withoutChannel: category.massObjects?.toFixed(1) ?? 0,
    percent: toPercent(category.massObjects, totalWasteMass).toFixed(1),
  }));
  return {
    donutDistribution: [
      {
        label: i18n.t("With channel"),
        value: Number(withOutletPercent.toFixed(1)),
      },
      {
        label: i18n.t("Without channel"),
        value: Number(withoutOutletPercent.toFixed(1)),
      },
    ],
    rows,
  };
};
export const buildMassParentTable = ({
  parentCategoriesList = [],
  totalWasteMass = 0,
  totalWeight = 0,
}) => {
  return parentCategoriesList.map((category) => ({
    label: startCase(i18n.t(category.parentCategory)),
    description: category.categoryList.map((item) => startCase(item)).sort(),
    massKg:
      totalWeight && totalWasteMass > 0
        ? (category.massObjects / totalWasteMass) * (totalWeight * 1000)
        : 0,
    percent: toPercent(category.massObjects, totalWasteMass),
  }));
};
